import Vue from 'vue'

const formatDate = iso => {
  if (!iso) return '—'
  return new Date(iso).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
}

const statusBadge = status => {
  const map = {
    pending: '<span class="badge bg-warning">Pending</span>',
    replied: '<span class="badge bg-info">Replied</span>',
    closed: '<span class="badge bg-secondary">Closed</span>',
  }
  return map[status] || status
}

const lastMessagePreview = item => {
  if (!item.last_message || !item.last_message.body) return '—'
  const body = item.last_message.body
  return body.length > 60 ? body.substring(0, 60) + '…' : body
}

const transform = item => ({
  ...item,
  status_badge: statusBadge(item.status),
  last_activity: formatDate(item.last_interaction_at || item.created_at),
  researcher_name: item.researcher ? item.researcher.name : '—',
  last_message_preview: lastMessagePreview(item),
})

export default {
  namespaced: true,
  state: {
    conversations: [],
    conversationsTotal: 0,
    conversation: null,
  },
  getters: {
    conversations: state => state.conversations,
    conversationsTotal: state => state.conversationsTotal,
    conversation: state => state.conversation,
  },
  mutations: {
    SAVE_CONVERSATIONS(state, conversations) {
      state.conversations = conversations
    },
    SAVE_CONVERSATIONS_TOTAL(state, total) {
      state.conversationsTotal = total
    },
    SAVE_CONVERSATION(state, conversation) {
      state.conversation = conversation
    },
    CLEAR_CONVERSATION(state) {
      state.conversation = null
    },
  },
  actions: {
    async filter({ commit }, filters = {}) {
      try {
        const resp = await Vue.prototype.$http.post(`${Vue.prototype.$groupUrl}/conversations/filter`, filters)
        commit('SAVE_CONVERSATIONS', resp.data.data.map(transform))
        commit('SAVE_CONVERSATIONS_TOTAL', resp.data.total)
      } catch (e) {
        console.log(e)
        commit('SAVE_CONVERSATIONS', [])
        commit('SAVE_CONVERSATIONS_TOTAL', 0)
      }
    },
    async fetchConversation({ commit }, id) {
      try {
        const resp = await Vue.prototype.$http.get(`${Vue.prototype.$groupUrl}/conversations/${id}`)
        commit('SAVE_CONVERSATION', resp.data.data)
      } catch (e) {
        console.log(e)
        throw e
      }
    },
    async sendMessage({ dispatch }, { id, body }) {
      const resp = await Vue.prototype.$http.post(`${Vue.prototype.$groupUrl}/conversations/${id}/messages`, { body })
      await dispatch('fetchConversation', id)
      return resp
    },
    async closeConversation({ dispatch }, id) {
      await Vue.prototype.$http.post(`${Vue.prototype.$groupUrl}/conversations/${id}/close`)
      await dispatch('fetchConversation', id)
    },
    clearConversation({ commit }) {
      commit('CLEAR_CONVERSATION')
    },
  },
}
